import { render, staticRenderFns } from "./GraveSelector.vue?vue&type=template&id=1533bbae&scoped=true"
import script from "./GraveSelector.vue?vue&type=script&lang=js"
export * from "./GraveSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1533bbae",
  null
  
)

export default component.exports